import { render, staticRenderFns } from "./PotatoForm.vue?vue&type=template&id=2a1c7e89"
import script from "./PotatoForm.vue?vue&type=script&lang=js"
export * from "./PotatoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports